"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokens = void 0;
var __vanilla_filescope__ = _interopRequireWildcard(require("@vanilla-extract/css/fileScope"));
var _css = require("@vanilla-extract/css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
__vanilla_filescope__.setFileScope("src/themeContract.cjs.css.ts", "@paypalcorp/pp-react-theme");
// @ts-ignore
// import {PAYPAL_TOKENS_CONTRACT} from '@paypalcorp/build/web/theme/paypal/tokens-contract'
// import {PAYPAL_TOKENS_TYPES} from '@paypalcorp/pp-tokens/build/web/theme/paypal/jsonTokensTypes'

var PAYPAL_TOKENS_CONTRACT = {
  size: {
    icon: {
      xs: '',
      sm: '',
      md: '',
      lg: '',
      xl: ''
    },
    pictogram: {
      sm: '',
      md: '',
      lg: ''
    },
    circle: {
      xs: '',
      sm: '',
      md: '',
      lg: '',
      xl: ''
    },
    tapTarget: {
      sm: '',
      "default": '',
      lg: '',
      tiny: '',
      xs: ''
    },
    pointerWidth: {
      sm: '',
      lg: ''
    },
    indicator: {
      xs: '',
      sm: '',
      md: '',
      lg: ''
    },
    field: {
      sm: '',
      lg: ''
    },
    media: {
      xs: '',
      sm: '',
      md: '',
      lg: '',
      xl: '',
      xxl: ''
    }
  },
  space: {
    '0': '',
    '25': '',
    '50': '',
    '75': '',
    '100': '',
    '150': '',
    '200': '',
    '250': '',
    '300': '',
    '350': '',
    '400': '',
    '450': '',
    '500': '',
    '600': '',
    '700': '',
    '800': '',
    '900': '',
    '1000': '',
    '1100': '',
    '1200': '',
    tiny: '',
    xs: '',
    sm: '',
    md: '',
    lg: '',
    xl: '',
    jumbo: ''
  },
  elevation: {
    level1: {
      yoffset: '',
      opacity: '',
      blur: ''
    },
    level2: {
      yoffset: '',
      opacity: '',
      blur: ''
    },
    level3: {
      yoffset: '',
      opacity: '',
      blur: ''
    },
    blurCurve: '',
    blurSlope: '',
    blurBase: '',
    opacity: '',
    brightenFactor: '',
    verticalOffsetRatio: '',
    horizontalOffsetRatio: ''
  },
  motion: {
    timing: {
      x1: '',
      y1: '',
      x2: '',
      y2: ''
    },
    duration: {
      hover: '',
      action: '',
      arrive: '',
      depart: '',
      repeat: '',
      linger: '',
      enter: {
        small: '',
        medium: '',
        large: ''
      },
      exit: {
        small: '',
        medium: '',
        large: ''
      },
      move: {
        small: '',
        medium: '',
        large: ''
      },
      loop: {
        backForth: '',
        standard: ''
      },
      pause: {
        read: '',
        reveal: ''
      }
    },
    easing: {
      enter: {
        small: '',
        medium: '',
        large: ''
      },
      exit: {
        small: '',
        medium: '',
        large: ''
      },
      move: {
        small: '',
        medium: '',
        large: ''
      },
      loop: {
        backForth: '',
        standard: ''
      }
    }
  },
  border: {
    thickness: {
      normal: '',
      emphasis: '',
      focus: '',
      focusOutline: ''
    },
    radius: {
      tiny: '',
      xs: '',
      sm: '',
      md: '',
      lg: '',
      xl: '',
      jumbo: '',
      interactive: ''
    }
  },
  typography: {
    displayStrong: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    displayMedium: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    display: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    displaySmStrong: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    displaySmMedium: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    displaySm: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    headingLgStrong: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    headingLgMedium: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    headingLg: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    headingSmStrong: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    headingSmMedium: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    headingSm: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    titleStrong: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    titleMedium: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    title: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    bodyStrong: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    bodyMedium: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    body: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    captionStrong: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    captionMedium: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    caption: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    linkLg: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      underline: '',
      maxScaleFactor: ''
    },
    linkSm: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      underline: '',
      maxScaleFactor: ''
    },
    tagStrong: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    tagMedium: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    tag: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    dataVizStrong: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    dataVizMedium: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    dataViz: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    buttonLg: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    buttonSm: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    fieldLabelLg: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    fieldLabelSm: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    fieldValueXl: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    fieldValueLg: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    fieldValueSm: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    navigationBarStrong: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    navigationBarMedium: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    navigationBar: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    legalStrong: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    legalMedium: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    },
    legal: {
      family: '',
      size: '',
      weight: '',
      lineHeight: '',
      letterSpacing: '',
      maxScaleFactor: ''
    }
  },
  blur: {
    interactive: ''
  },
  color: {
    background: {
      main: '',
      alt: '',
      surface: '',
      surfaceHover: '',
      surfaceActive: '',
      highContrast: '',
      mediumContrast: ''
    },
    primary: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: '',
      contrastHover: '',
      contrastActive: ''
    },
    secondary: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: ''
    },
    tertiary: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: '',
      contrastHover: '',
      contrastActive: ''
    },
    featured: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: ''
    },
    promotion: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: '',
      medium: {
        main: '',
        mainHover: '',
        mainActive: '',
        contrast: ''
      },
      light: {
        main: '',
        mainHover: '',
        mainActive: '',
        contrast: ''
      },
      moderate: {
        main: '',
        mainHover: '',
        mainActive: '',
        contrast: ''
      },
      soft: {
        main: '',
        mainHover: '',
        mainActive: '',
        contrast: ''
      }
    },
    unselected: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: ''
    },
    selected: {
      main: '',
      mainHover: '',
      mainActive: '',
      alt: '',
      altHover: '',
      altActive: '',
      contrast: ''
    },
    selectedRange: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: ''
    },
    link: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: '',
      contrastHover: '',
      contrastActive: '',
      alt: '',
      altHover: '',
      altActive: ''
    },
    overlay: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: ''
    },
    overlayInverse: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: ''
    },
    accent1: {
      main: '',
      contrast: ''
    },
    accent2: {
      main: '',
      contrast: ''
    },
    accent3: {
      main: '',
      contrast: ''
    },
    accent4: {
      main: '',
      contrast: ''
    },
    error: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: '',
      medium: {
        main: '',
        mainHover: '',
        mainActive: '',
        contrast: ''
      }
    },
    warning: {
      main: '',
      mainHover: '',
      mainActive: '',
      alt: '',
      contrast: '',
      medium: {
        main: '',
        mainHover: '',
        mainActive: '',
        contrast: ''
      }
    },
    success: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: '',
      medium: {
        main: '',
        mainHover: '',
        mainActive: '',
        contrast: ''
      }
    },
    system: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: ''
    },
    info: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: ''
    },
    specialty: {
      main: '',
      mainHover: '',
      mainActive: '',
      contrast: '',
      medium: {
        main: '',
        mainHover: '',
        mainActive: '',
        contrast: ''
      }
    },
    structure: {
      borderHighContrast: '',
      borderLowContrast: '',
      divider: '',
      focus: '',
      scrim: '',
      shimmer: '',
      shimmerInverse: '',
      sheen: '',
      shadow: '',
      focusOutline: '',
      errorOutline: ''
    }
  }
};
var tokenContract = PAYPAL_TOKENS_CONTRACT;
var tokens = exports.tokens = (0, _css.createThemeContract)(tokenContract);
__vanilla_filescope__.endFileScope();
